var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leave-dialog"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"content"}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"btn"},[_c('img',{attrs:{"src":require("@/assets/images/return-dialog.png"),"alt":""},on:{"click":_vm.returnTo}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }